import { IGpsItemsForCentralRecords, IGpsItemsForList } from '@nkr/models/index';
import { FormEvent, useState } from 'react';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from 'react-bootstrap';


interface IProps {
    show: boolean,
    data: IGpsItemsForCentralRecords,
    onFieldChange: (e: FormEvent<FormControl & HTMLInputElement>) => void,
    onConfirm: () => void,
    onCancel: () => void
}

const AddTrackingComments = (props: IProps) => {
    const [validTrackingComments, setValidTrackingComments] = useState(true);

    const handleConfirm = () => {
        let isValid = props.data.gpsComments != '';

        setValidTrackingComments(isValid);

        if (isValid) {
            props.onConfirm();
        }
    };

    const handleCancel = () => {
        setValidTrackingComments(true);
        props.onCancel();
    };

    const swapNumber = props.data != null ? props.data.swapNumber : '';
    const trackingComment = props.data != null ? props.data.gpsComments : '';
    const gpsNumber = props.data != null ? props.data.gpsNumber : '';



    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Enter Comment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!validTrackingComments && (
                    <Alert bsStyle='danger' style={{ padding: '7.5px 15px' }}>
                        **All Fields Required** &nbsp;&nbsp;
                        Please correct the issues below...
                    </Alert>
                )}

                <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                    <Row>
                        <Col xs={12} lg={1}>Swap:</Col>
                        <Col xs={12} lg={10}>{swapNumber}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={1}>GPS:</Col>
                        <Col xs={12} lg={10}>{gpsNumber}</Col>
                    </Row>
                </Alert>

                <FormGroup validationState={validTrackingComments ? null : 'error'}>
                    <ControlLabel>Enter comments here</ControlLabel>
                    <FormControl
                        id='gpsComments'
                        name='gpsComments'
                        componentClass='textarea'
                        style={{ width: '100%' }}
                        placeholder='Enter comment'
                        value={trackingComment}
                        onChange={props.onFieldChange}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleConfirm}>{trackingComment.length > 0 ? 'Update' : 'Add'} Tracking Comment</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddTrackingComments;